import { isDefined } from "@clipboard-health/util-ts";
import { isEmpty } from "lodash";

import { logError } from "../lib/analytics";
import { type RenderCustomMessageProps } from "./type";

export function parseFacilityChatMessage(message: RenderCustomMessageProps["message"]) {
  let facilityMessage;
  try {
    if ("message" in message && typeof message.message === "string") {
      ({ facility: facilityMessage } = JSON.parse(message.message) as { facility: string });
    }

    return facilityMessage;
  } catch (error) {
    logError("Failed to parse facility message from chat message", {
      error,
      metadata: { message },
    });
    return undefined;
  }
}

export function parseShiftInviteChatMessage(props: RenderCustomMessageProps) {
  const { message } = props;
  const defaultData = { shiftInviteId: undefined, status: undefined };
  try {
    const facilityMessage = parseFacilityChatMessage(message);

    const { shiftInviteId, status } =
      isDefined(message.data) && !isEmpty(message.data)
        ? (JSON.parse(message.data) as {
            shiftInviteId: string;
            status: string;
          })
        : defaultData;
    return { facilityMessage, shiftInviteId, status };
  } catch (error) {
    logError("Shift Invite Chat Message Parsing Error", { error, metadata: { message } });
    return { facilityMessage: undefined, ...defaultData };
  }
}
